import React from 'react'
import { BackLink } from '../../components/BackLink/BackLink'
import { choicePage } from '../../pages'
import { ComplaintForm } from '../ComplaintForm'
import { complaintType } from '../../choices'
import { complaintTypeChoice } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withDocTitle } from '../../components/withDocTitle'
import css from '../ComplaintForm/ComplaintForm.module.css'

export class ComplaintTypeChoiceForm extends React.Component {
  backLink = (
    <BackLink href="https://oig.hhs.gov/fraud/report-fraud">Back</BackLink>
  )

  // Defines both the order to display choices and their corresponding routes
  choiceOrderAndRoute = {
    healthcare_fraud: routes.healthcare.form,
    fraud_waste_abuse: routes.fraudwasteabuse.form,
    whistleblower_retaliation: routes.whistleblower.base,
    grant_contract_fraud: routes.grantcontractfraud.form,
    quality_of_care: routes.qualityofcare.form,
    medical_identity_theft: routes.medicalidtheft.form,
    child_support: routes.childsupport.form,
    agent_import_permit_fraud: routes.agentimportpermitfraud.form,
    other_complaint: routes.othercomplaint.form
  }

  choiceOptions = complaintType()

  choices = Object.keys(this.choiceOrderAndRoute).map(key =>
    this.choiceOptions.filter(obj => obj.value === key).pop()
  )

  schema = {
    onSubmit: formValues => this.handleComplaintChoice(formValues),
    pages: [
      {
        ...choicePage({
          pageId: 'complaint_type_choice_page',
          fieldName: 'complaint_type_choice',
          className: css.choices,
          label: 'What is your complaint regarding?',
          labelClassName: css.largeLabel,
          choices: this.choices
        }),
        action: {
          type: 'next',
          buttonText: 'Continue'
        }
      }
    ]
  }

  handleComplaintChoice = formValues => {
    this.props.history.push(
      this.choiceOrderAndRoute[formValues['complaint_type_choice']]
    )
  }

  render() {
    return <ComplaintForm schema={this.schema} headerContent={this.backLink} />
  }
}

export default withDocTitle(ComplaintTypeChoiceForm, complaintTypeChoice)
